import { CashbackInfo, ClaimCashbackPayload, HTTPResponse } from '../../../models';
import { BaseApiService } from '../../base-api-service';
import { ApiVersions } from '../../../enums';
import { env } from '../../../environment';

class CashbackController extends BaseApiService {

  public async getCashbackInfo(gameId: number): Promise<CashbackInfo> {
    const url = `${this.url}/cashback/api/${ApiVersions.V1}/userCashback`;
    return await this.http.get(url, { params: { gameId } });
  }

  public async claimCashback(data: ClaimCashbackPayload): Promise<HTTPResponse> {
    const url = `${this.url}/cashback/api/${ApiVersions.V1}/userCashback/claim`;
    return await this.http.post(url, data, { skipInterceptor: true });
  }

}

export const cashbackController = new CashbackController({ url: env.origin });
